import React from 'react';

import Job from '../Components/Job';

const BehaviorSupervisor = () => <Job title="supervisor" />

export default BehaviorSupervisor;
